import React, { FC } from 'react';
import styled from 'styled-components';

import { WithChildren } from '@investown/fe/common-utils';

const MenuItemContainer: FC<WithChildren> = ({ children }) => (
  <StyledMenuItemContainer>{children}</StyledMenuItemContainer>
);

const StyledMenuItemContainer = styled.div`
  display: flex;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}) {
    flex-direction: column;
  }
  align-items: center;

  & > span {
    line-height: 1;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.large}) {
      margin-left: ${(props) => props.theme.margins.medium};
    }
  }
`;

export default MenuItemContainer;
